import React, { Component } from 'react';
import * as axios from 'axios';
import PropTypes from 'prop-types';
import './SiteLevelAlert.scss';
import Cookies from 'universal-cookie';


declare var jQuery: any;
class SiteLevelAlert extends Component {


	constructor(props) {
		super(props);
		this.cookies = new Cookies();
		let show = (this.cookies.get('showAlert')) ? parseInt(	this.cookies.get('showAlert')) : true;

		this.defaults = {
			'title': 'Alert',
			'linkText': 'Read More',
			'type': 'severe',
			'cookieDurationInHours':  2
		}
		this.state = {
			data: Object.assign({}, this.props, this.defaults),
			show: show,
			paddingTop: jQuery('body').css('margin-top')
		};
		

		this.dismissAlert = this.dismissAlert.bind(this);
	}

  	componentDidMount() {
  		var padding = jQuery('.alert-level-site-component').css('height', 'auto').outerHeight();
  		this.setState({paddingTop: padding});

	    jQuery('body > div.wrapper').css('padding-top', padding);
	    jQuery('.main-header-container').css('top', padding);
	}    

	dismissAlert() {
		var d = new Date();
		var minutes = parseInt(this.state.data.cookieDurationInHours)*60;
		d.setTime(d.getTime() + minutes*60*1000); // in milliseconds

		this.setState({show: false});
		this.cookies.set('showAlert', false, {
			path: '/',
			domain: '.njit.edu',
			expires: d
		});
		jQuery('body > div.wrapper').css('padding-top', '0px');
	    jQuery('.main-header-container').css('top', '0px');
	}

  	render() {
  		if(this.state.show) {
	  		return (
		      <div className="alert-level-site-component">
				  <div className="content">
				  	<div className="closeBtn" onClick={this.dismissAlert}><i className="fa fa-times-circle" aria-hidden="true"></i></div>
				    <h3>{this.state.data.title}</h3>
				    <p>
				      {this.props.data.body} 
				      <a className="the-link" href={this.state.data.link}>{this.state.data.linkText}</a>
				    </p>
				  </div>
				</div>
		    );
	    } else {
	    	return null;
	    }
  	}
}

SiteLevelAlert.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  link: PropTypes.string,
  cookieDurationInHours: PropTypes.number,
 
  // A value of any data type
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};

export default SiteLevelAlert;










// WEBPACK FOOTER //
// ./src/SiteLevelAlert/SiteLevelAlert.js